import React from "react"


import Layout from "../components/layout"

import SEO from "../components/seo"

import "../components/css/unicorn.min.css"

const IndexPage = () => (
  
  <Layout>
    <SEO title="Home" />
  </Layout>
)

export default IndexPage
